export default __webpack_public_path__ + "static/media/activity_filled.ded1ba91.png";